/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2026-02-03 17:50:26
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-27 10:36:09
 */
import request from '@/utils/request'
import * as mock from '@/mock'

const isMock = process.env.VUE_APP_USE_MOCK === 'true'

// 获取集团门店列表（用于获取appid）
export const getGroupStoreList = () =>
  isMock ? mock.getGroupStoreList() : request.post('/dashboardTc/getGroupStoreList')

// 左侧板块 - 1. 顶部统计卡片
export const getStatsCards = () =>
  isMock ? mock.getStatsCards() : request.post('/dashboardTc/getStatsCards')

// 左侧板块 - 2. 月采购订单量统计（折线图）
export const getOrderLineChart = appid =>
  isMock
    ? mock.getOrderLineChart({ appid })
    : request.post('/dashboardTc/getOrderLineChart', { appid })

// 左侧板块 - 3. 月采购金额统计（折线图）
export const getAmountLineChart = appid =>
  isMock
    ? mock.getAmountLineChart({ appid })
    : request.post('/dashboardTc/getAmountLineChart', { appid })

// 左侧板块 - 4. 产品类型销量统计（饼图）
export const getSaleTypePie = appid =>
  isMock ? mock.getSaleTypePie({ appid }) : request.post('/dashboardTc/getSaleTypePie', { appid })

// 左侧板块 - 5. 产品类型销售额统计（柱状图）
export const getSaleTypeBar = appid =>
  isMock ? mock.getSaleTypeBar({ appid }) : request.post('/dashboardTc/getSaleTypeBar', { appid })

// 左侧板块 - 6. 商品销量排行
export const getProductSalesRank = appid =>
  isMock
    ? mock.getProductSalesRank({ appid })
    : request.post('/dashboardTc/getProductSalesRank', { appid })

// 左侧板块 - 7. 商品销售额排行
export const getProductAmountRank = appid =>
  isMock
    ? mock.getProductAmountRank({ appid })
    : request.post('/dashboardTc/getProductAmountRank', { appid })

// 中间板块 - 1. 实时累积交易金额（Flop）
export const getPlatformTotal = () =>
  isMock ? mock.getPlatformTotal() : request.post('/dashboardTc/getPlatformTotal')

// 中间板块 - 2. 地图数据（始终使用本地数据）
export const getMapData = () => mock.getMapData()

// 中间板块 - 3. 地图表格数据（MapTable）
export const getMapTableData = params =>
  isMock ? mock.getMapTableData(params) : request.post('/dashboardTc/getMapTableData', params)

// 右侧板块 - 1. 学校采购排行
export const getSchoolPurchaseRank = params =>
  isMock
    ? mock.getSchoolPurchaseRank(params)
    : request.post('/dashboardTc/getSchoolPurchaseRank', params)

// 右侧板块 - 2. 万象/联合体月度统计
export const getWanxiangMonthlyStats = () =>
  isMock ? mock.getWanxiangMonthlyStats() : request.post('/dashboardTc/getWanxiangMonthlyStats')

// 右侧板块 - 3. 供应商销售排行
export const getSupplierSalesRank = params =>
  isMock
    ? mock.getSupplierSalesRank(params)
    : request.post('/dashboardTc/getSupplierSalesRank', params)

// 弹窗接口 - 1. 在售商品分页查询
export const getOnsaleProductList = params =>
  isMock
    ? mock.getOnsaleProductList(params)
    : request.post('/dashboardTc/getMaterialOnSalePage', params)

// 弹窗接口 - 2. 采购学校分页查询
export const getSchoolList = params =>
  isMock ? mock.getSchoolList(params) : request.post('/dashboardTc/getSchoolPurchasePage', params)

// 弹窗接口 - 3. 采购订单分页查询
export const getPurchaseOrderList = params =>
  isMock ? mock.getPurchaseOrderList(params) : request.post('/dashboardTc/getOrderPage', params)

export const plaformInfo = params => request.post('/dashboard/get/platform/info', params)

export const areaCompanyOrder = params => request.post('/dashboard/area/company/order/page', params)
export const areaCompanyProduct = params =>
  request.post('/dashboard/area/company/product/page', params)
export const bizCusPage = params => request.post('/dashboard/biz/cus/page', params)
export const bizOrderPage = params => request.post('/dashboard/biz/order/page', params)
export const bizSupplierPage = params => request.post('/dashboard/biz/supplier/page', params)
export const getAreaSaleTotalDetail = params =>
  request.post('/dashboard/get/area/sale/total/detail', params)
export const groupMaterialPage = params => request.post('/dashboard/group/material/page', params)
export const groupOrderPage = params => request.post('/dashboard/group/order/page', params)
export const onsaleMaterailPage = params => request.post('/dashboard/onsale/material/page', params)
export const userCusPage = params => request.post('/dashboard/user/cus/page', params)
export const userOrderPage = params => request.post('/dashboard/user/order/page', params)
